export default __webpack_public_path__ + "static/pdp--product-1-f54f63b0d2c1c5f5fcf726b7ff8ea101.jpg";